const allSwatches = document.querySelectorAll('.variant-swatch-label');
const variantsBundleWrapper = document.querySelector('.variants-bundle-wrapper');
const variantsBundleWrapperChangeImage = document.querySelector('.variants-bundle-wrapper[data-change-image="true"]');
const preSelectedSwatch = variantsBundleWrapper?.querySelector('.variant-swatch-label.active');
const productFormSubmit = document.querySelector('.product-form__submit');
const propertiesContainer = document.querySelector('.variants-selected-properties__container');
const tooltips = document.querySelectorAll('.tooltip');
const productFormPrecommande = document.querySelector('.product-form__precommande');
const preorderContent = document.querySelector('.product-form__precommande div');
const addToCartText = document.querySelector('.button--atc-and-price span');
const alertText = document.querySelector('#alert-text-container');
const limit = parseInt(variantsBundleWrapper.dataset.limit, 10);
const mediaGallery = document.querySelector('media-gallery');

let limitCount = 0;
let preorderArray = [];

function handleSubmitState() {
    if (limitCount !== limit) return false;
    return true;
}

productFormSubmit.addEventListener('click', (e) => {
  if (!handleSubmitState()) {
    e.preventDefault();
    const legendContainer = document.querySelector('.variant-bundle__legend-container');
    const message = alertText != null ? alertText.innerText.charAt(0).toUpperCase() + alertText.innerText.slice(1).toLowerCase() : 'Attention vous devez choisir vos couleurs';

    let existingMessage = legendContainer.querySelector('p');
    if (existingMessage) {
      existingMessage.innerText = message;
    } else {
      legendContainer.innerHTML += `<p class="variant-bundle__alert">${message}</p>`;
      if(document.querySelector('#button-sticky__with-variants') != null) {
        window.scrollTo(window.scrollX, anchorToScrollTo.offsetTop - 150);
      }
      if (document.querySelector('.button-sticky__with-variants--is-clicked')) {
        document.querySelector('.button-sticky__with-variants--is-clicked').classList.toggle('button-sticky__with-variants--is-clicked')
      }
    }
  } else {
    e.preventDefault();
    addPropertiesToForm();
    document.querySelector('product-form').onSubmitHandler(e);
  }
});

function rgbToHex(rgb) {
    // Sépare les valeurs R, G et B de la chaîne RGB
    var regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
    var match = regex.exec(rgb);
    var r = parseInt(match[1]);
    var g = parseInt(match[2]);
    var b = parseInt(match[3]);

    // Convertit les valeurs R, G et B en hexadécimal
    var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    // Renvoie la valeur hexadécimale
    return hex;
}

function isLight(color) {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
}

// Change text color if background is too light
for (let i = 0; i < tooltips.length; i++) {
    let tooltip = tooltips[i];
    let color = tooltip.style.background;
    if (color != '') {
        color = rgbToHex(color);
        if (isLight(color)) {
            tooltip.style.color = '#000';
        }
    }
}

// Tooltip function that follow the mouse pointer on hover
function followPointer(event, swatch) {
    var x = event.clientX,
        y = event.clientY,
        clientWidth = window.innerWidth,
        widthBetweenMouseAndEdge = clientWidth - x,
        tooltip = swatch.querySelector('.tooltip'),
        tooltipWidth = tooltip ? tooltip.offsetWidth : 0;

    if (!tooltip) return;

    console.log(x, clientWidth, widthBetweenMouseAndEdge, tooltipWidth);

    if (widthBetweenMouseAndEdge < tooltipWidth) {
        tooltip.style.left = (x - tooltipWidth - 10) + 'px';
    } else {
        tooltip.style.left = (x + 10) + 'px';
    } 
    
    tooltip.style.top = (y + 5) + 'px';
}

allSwatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
        selectColor(swatch)
    })
    swatch.addEventListener('mousemove', function (event) {
        followPointer(event, swatch)
    })
    if (swatch.classList.contains('active')) {
        swatch.click();
    }
})

function selectColor(swatch) {
    var qtyLabel = swatch.querySelector('.product-selected-number');
    if (swatch.dataset.method == 'increment') {
        swatch.dataset.quantity++;
        limitCount++;
    } else {
        swatch.dataset.quantity--;
        limitCount--;
        if (swatch.dataset.quantity == 0) swatch.dataset.method = "increment";
    }

    updateQuantityLabel(swatch, qtyLabel);
    updateSwatchState(swatch, qtyLabel);
    updateProductGallery(swatch, qtyLabel);

    // Enlever le message si une couleur est sélectionnée
    const legendContainer = document.querySelector('.variant-bundle__legend-container');
    let existingMessage = legendContainer.querySelector('p');
    if (existingMessage) {
        existingMessage.remove(); // Supprimer le message
    }

    const nearLimit = limit - 1;

    switch (limitCount) {
        case limit:
            document.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
                swatch.dataset.method = "decrement";
            });
            document.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
                swatch.classList.add('variant-swatch-label-disabled');
            });
            break;
        case 0:
            document.querySelectorAll('.variant-swatch').forEach((swatch) => {
                swatch.dataset.method = "increment";
            });
            document.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
                swatch.classList.remove('variant-swatch-label-disabled');
            });
            break;

        default:
            document.querySelectorAll('.variant-swatch:not(.active)').forEach((swatch) => {
                swatch.classList.remove('variant-swatch-label-disabled');
            });
            break;
    }

    const messageCompleted = document.querySelector('.variant-bundle__legend-container-message-completed');
    if (limitCount === limit) {
        let selectedColors = [];
        document.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
            for (let i = 0; i < swatch.dataset.quantity; i++) {
                selectedColors.push(swatch.dataset.name);
            }
        });
        let selectedColorsString = selectedColors.join(' x ');
        document.querySelector('.variant-bundle__legend-container legend').innerText = '🎉 Sélection : ' + selectedColorsString;
        if (messageCompleted) messageCompleted.classList.remove('hidden');
    } else if (limitCount === nearLimit) {
        document.querySelector('.variant-bundle__legend-container legend').innerText = 'Plus qu\'une couleur à choisir :';
        if (messageCompleted) messageCompleted.classList.add('hidden');
    } else {
        document.querySelector('.variant-bundle__legend-container legend').innerText = 'Choisissez vos couleurs :';
        if (messageCompleted) messageCompleted.classList.add('hidden');
    }
    handlePreorder(swatch);
}

function updateQuantityLabel(swatch, qtyLabel) {
    qtyLabel.innerHTML = swatch.dataset.quantity
    qtyLabel.style.visibility = "visible";
    if (parseInt(qtyLabel.innerHTML) === 0) qtyLabel.style.visibility = "hidden";
}

function updateSwatchState(swatch, qtyLabel) {
    swatch.classList.add('active');
    if (parseInt(qtyLabel.innerHTML) === 0) swatch.classList.remove('active');
}

function updateProductGallery(swatch, qtyLabel) {
    if (variantsBundleWrapperChangeImage !== null && mediaGallery !== null) {
        const variantsBundleWrapperOriginalImage = document.querySelector('.variants-bundle-wrapper[data-original-image]');
        let swatchImageUrl = swatch.dataset.image.split('&width=').shift();
        let productMediaFirstImg = mediaGallery.querySelector('.product__media-list .product__media-item .product__media img');
        let productMediaFirstImgBaseUrl = productMediaFirstImg.getAttribute('src').split('&width=').shift().replace('https:', '');
        let productThumbFirstImg = mediaGallery.querySelector('.thumbnail-list .thumbnail-list__item .thumbnail img');
        let productThumbFirstImgBaseUrl = productThumbFirstImg.getAttribute('src').split('&width=').shift().replace('https:', '');

        if (parseInt(qtyLabel.innerHTML) === 0) {
            swatchImageUrl = variantsBundleWrapperChangeImage.dataset.originalImage.split('&width=').shift();
        }

        if (productMediaFirstImg !== null) {
            if (variantsBundleWrapperOriginalImage === null) variantsBundleWrapperChangeImage.setAttribute('data-original-image', productThumbFirstImgBaseUrl);

            const newMediaSrc = productMediaFirstImg.getAttribute('src').replace(productMediaFirstImgBaseUrl, swatchImageUrl);
            const newMediaSrcset = productMediaFirstImg.getAttribute('srcset').replaceAll(productMediaFirstImgBaseUrl, swatchImageUrl);
            productMediaFirstImg.setAttribute('src', newMediaSrc);
            productMediaFirstImg.setAttribute('srcset', newMediaSrcset);

            const newThumbSrc = productThumbFirstImg.getAttribute('src').replace(productThumbFirstImgBaseUrl, swatchImageUrl);
            const newThumbSrcset = productThumbFirstImg.getAttribute('srcset').replaceAll(productThumbFirstImgBaseUrl, swatchImageUrl);
            productThumbFirstImg.setAttribute('src', newThumbSrc);
            productThumbFirstImg.setAttribute('srcset', newThumbSrcset);

            productThumbFirstImg.closest('button').click();
        }
    }
}

function addPropertiesToForm() {
    var index = 1;
    var preorderAdded = false; // Variable pour vérifier si les propriétés de précommande ont été ajoutées
    var preorderSwatch = null;

    document.querySelectorAll('.variant-swatch.active').forEach((swatch) => {
        for (let i = 0; i < swatch.dataset.quantity; i++) {
            propertiesContainer.innerHTML += '<input type="hidden" name="properties[Couleur ' + index + ']" value="' + swatch.dataset.name + '">';
            propertiesContainer.innerHTML += '<input type="hidden" name="properties[COLOR-SKU ' + index + ']" value="' + swatch.dataset.sku + '">';

            if(swatch.dataset.preorder == 'true' && !preorderAdded){ // Ajouter les propriétés de précommande uniquement si elles n'ont déjà été ajoutées
                preorderAdded = true; // Mettre la variable à true pour indiquer que les propriétés de précommande ont été ajoutées
                preorderSwatch = swatch;
            }

            index++;
        }
    });

    // Ajouter les propriétés de précommande à la fin
    if (preorderAdded) {
        propertiesContainer.innerHTML += `<input type="hidden" name="properties[Precommande]" value="${preorderContent.dataset.content + preorderSwatch.dataset.precoDate}">`;
    }
}

 function handlePreorder(swatch){
     // Preorder
     if (swatch.dataset.preorder == 'true' && !preorderArray.some((swotch) => swotch.name == swatch.dataset.name)) {
         preorderArray.push({
             name: swatch.dataset.name,
             quantity: swatch.dataset.quantity
         })
     } else if (swatch.dataset.preorder == 'true' && swatch.dataset.quantity == 0) {
         preorderArray = preorderArray.filter((swotch) => swotch.name != swatch.dataset.name);
     }
    
     if(preorderArray.length > 0) {
        if(swatch.dataset.precoDate != "") {
         preorderContent.innerHTML = preorderContent.dataset.content + swatch.dataset.precoDate;
         console.log(addToCartText.textContent);
         console.log(window.variantStrings.soldOut);
         if(addToCartText.textContent.trim() != window.variantStrings.soldOut.trim()) {
            addToCartText.innerHTML = "Pré-commander";
         }
        }
     } else {
         preorderContent.innerHTML = '';
         if(addToCartText.textContent.trim() != window.variantStrings.soldOut.trim()) {
          addToCartText.innerHTML =  window.variantStrings.addToCart;
         }
     }
 }